import type { ExtractResource, ResourceType } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { createReference } from '@seen/core/references'
import type { JSX, ReactNode } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useFhirRead } from '#src/hooks/useFhirRead.ts'

export function BaseBreadcrumb({
  to,
  label,
}: {
  to: string
  label: ReactNode
}): JSX.Element {
  return (
    <Link to={to} className="text-inherit no-underline hover:underline">
      {label}
    </Link>
  )
}

export function ResourceBreadcrumb<T extends ResourceType>({
  to,
  resourceType,
  resourceId,
  getLabel,
}: {
  to: string
  resourceType: T
  resourceId: string
  getLabel?: (resource: ExtractResource<T>) => string | ReactNode
}): JSX.Element | null {
  const resourceQuery = useFhirRead(resourceType, resourceId)

  return resourceQuery.data ? (
    <BaseBreadcrumb
      to={to}
      label={
        getLabel
          ? getLabel(resourceQuery.data)
          : referenceDisplay(createReference(resourceQuery.data))
      }
    />
  ) : null
}
